import styled from 'styled-components';
import { color } from 'styles/colors';

export const container: any = styled.div`
  position: relative;

  width: 100%;
  height: 200px;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  > svg {
    font-size: 2rem;
    color: ${color.interface.lightGray};
  }

  > p {
    font-size: 1.3rem;
    opacity: 0.8;
    color: ${color.interface.lightGray};
  }
`;

export const videoEmbed: any = styled.div`
  z-index: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(255, 255, 255, 0.5);
  > iframe {
    all: unset;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const noData: any = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.5rem;
  background-color: ${color.interface.white};

  > p {
    width: 80%;
    text-align: center;
    font-size: 1.3rem;
    color: ${color.interface.lightGray};
  }
`;

export const notice: any = styled.div`
  width: 100%;

  > p {
    text-align: center;
    font-size: 1rem;
    color: ${color.interface.lightGray};
  }
`;
